interface Props {
  name: string;
  login: string | null;
  email?: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * Shows a person's name + secondary identifier (email preferred, @login fallback).
 * When the name IS the login (e.g. "Aswin-5c" == "@Aswin-5c"), shows the name alone.
 */
export default function PersonIdentity({ name, login, email, size = 'md', className = '' }: Props) {
  const nameClass = size === 'lg' ? 'text-base font-semibold'
    : size === 'sm' ? 'text-xs font-semibold'
    : 'text-sm font-semibold';
  const subClass = size === 'lg' ? 'text-sm'
    : size === 'sm' ? 'text-xxs'
    : 'text-xs';

  const secondary = pickSecondary(name, login, email);

  return (
    <div className={`min-w-0 ${className}`}>
      <div className={`${nameClass} text-fg truncate`}>{name}</div>
      {secondary && (
        <div className={`${subClass} text-fg-subtle truncate`}>{secondary}</div>
      )}
    </div>
  );
}

function pickSecondary(name: string, login: string | null, email?: string | null): string | null {
  if (email) return email;
  if (login && login.toLowerCase() !== name.toLowerCase()) return `@${login}`;
  return null;
}
